import { mutatorAction } from "satcheljs";
import type SearchScenarioId from "../store/schema/SearchScenarioId";
import getScenarioStore from "../selectors/getScenarioStore";

const setEntityRecognitionAppliedMutator: (scenarioId: SearchScenarioId, applied: boolean) => void = mutatorAction("setEntityRecognitionApplied", (scenarioId: SearchScenarioId, applied: boolean): void => {
    getScenarioStore(scenarioId).entityRecognitionApplied = applied;
});

export default setEntityRecognitionAppliedMutator;
